import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';

const trackSearchAction = (url, keyword, categoryIDs, manufacturers, models, listingTypes, useDefaultListingTypes, isAttachment, conditions) => {
    sandhillsRequest({
        url: url,
        method: 'post',
        data: {
            actionName: 'search',
            email: '',
            manufacturers: manufacturers,
            models: models,
            categoryIDs: categoryIDs,
            listingTypes: listingTypes,
            conditions: conditions,
            additionalProperties: [{
                key: 'keyword',
                value: keyword
            }],
            useDefaultForSaleListingTypes: useDefaultListingTypes,
            isAttachment: isAttachment || false
        },
        errorHandling: {
            useConsole: false,
            useAlert: false
        }
    });
};

const trackAutocompleteSearchAction = (url, item) => {
    let manufacturers = [];
    let models = [];
    let keyword = null;
    let categoryIDs = [];
    switch (item.TermType) {
        case 'Manufacturer':
            manufacturers = [item.Term];
            keyword = item.value;
            break;
        case 'ManuModel':
            if (item.Term) {
                let terms = item.Term.split('|splt|');
                if (terms[0]) {
                    manufacturers = [terms[0]];
                }

                if (terms.length > 1 && terms[1]) {
                    models = [terms[1]];
                }
            }
            keyword = item.value;
            break;
        case 'Keyword':
            keyword = item.value;
            break;
        case 'Category':
            categoryIDs = [item.Term];
            keyword = item.value;
            break;
    }
    trackSearchAction(url, keyword, categoryIDs, manufacturers, models, null, true, item.IsAttachment, null);
};

export {
    trackSearchAction,
    trackAutocompleteSearchAction
};